module.exports = __webpack_public_path__ + "img/538e6ed.png";